"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEBRTC_STATES = exports.JANUS_CLIENT_ID = void 0;
var JANUS_CLIENT_ID = exports.JANUS_CLIENT_ID = 'janus';
var WEBRTC_STATES = exports.WEBRTC_STATES = {
  INIT: 0,
  CONNECTING: 1,
  CONNECTED: 2,
  READY: 3,
  DISCONNECTED: 4,
  CLOSED: 5,
  FAILED: 6
};